import axios from 'axios'
import moment from 'moment/moment'
import current from './current'
import Vue from 'vue'
import {mapActions} from 'vuex'

const state = {
  currentView: 'list', // gant // kanban
  listrefresh: false,
  currentprojectid: null,
  isEdit: false,
  loading: false,
  tickets: [],
  meta: {},
  currentTicket: null,
  ticketmodel: {
    id: '',
    items: {
      images: [],
      documents: [],
      flaws: []
    },
    trade: [],
    comments: [],
    history: [],
    shares: [],
    responsible_id: 0,
    status: 10,
    createmode: false
  },
  servicesWithCompanies: [],
  responsibleUsers: [],
  statuslist: [
    {id: 10, title: 'erstellt',                 aclass: '', color: '#DC3546'},
    {id: 20, title: 'versendet',                aclass: '', color: '#DC3546'},
    {id: 30, title: 'gesehen',                  aclass: '', color: '#DC3546'},
    // {id: 40, title: 'akzeptiert',               aclass: '', color: '#fcfccc'},
    // {id: 50, title: 'abgelehnt',                aclass: '', color: '#FF0000'},
    {id: 60, title: 'in Bearbeitung',           aclass: '', color: '#FF9100'},
    {id: 70, title: 'zu besprechen',            aclass: 'fa-beat', color: '#F700B6'},
    {id: 80, title: 'erledigt (zur Prüfung)',   aclass: '', color: '#FFEB00'},
    {id: 90, title: 'abgeschlossen',            aclass: '', color: '#99FF99'}
  ],
  searchstring: '',
  shareoptions: {
    internal: [],
    external: []
  },
  selectedRecords: [],
  selectedTasks: []
}
const mutations = {
  updateTicket(state, newValue) { state.currentTicket = newValue },
  setIsEdit(state, payload) {
    // console.log('setIsEdit', payload)
    state.isEdit = payload;
  },
  setTicket(state, payload) {
    // console.log('setIsEdit', payload)

    if(payload === null) {
      state.currentTicket = state.ticketmodel
    } else {
      state.currentTicket = payload
    }
  },
  setSearchstring(state, payload) {
    if(payload === null) {
      state.searchstring = null
    } else {
      state.searchstring = payload
    }
  },
  setServicesWithCompanies: (state, payload) => {state.servicesWithCompanies = payload},
  setResponsibleUsers: (state, payload) => {state.responsibleUsers = payload},
  setCurrentTicket(state, item) {
    state.currentTicket = item;
  },
  setLoading(state, value) {
    state.loading = value
  },
  setListRefresh(state, value) {
    state.listrefresh = value
  },
  SET_COMMENTS(state, comments) {
    Vue.set(state.currentTicket, 'comments', comments);
  },
  SET_HISTORY(state, history) {
    Vue.set(state.currentTicket, 'history', history);
  },
  SET_SHARES(state, shares) {
    Vue.set(state.currentTicket, 'shares', shares);
  },
  SET_STATUS(state, status) {
    Vue.set(state.currentTicket, 'status', status);
  },
  SET_VIEWSTATE(state, viewstate) {
    Vue.set(state.currentView, viewstate, status);
  },
  REMOVE_TICKET(state, ticketId) {
    state.tickets = state.tickets.filter(ticket => ticket.id !== ticketId);
  }
}
const actions = {
  setViewState({commit, state}, viewstate) {
    state.currentView = viewstate
  },
  resetTickets({commit}) {
    state.tickets = []
    state.currentTicket = null
    state.servicesWithCompanies = []
    state.responsibleUsers = []
  },

  async getProjectServicesWithCompany({ commit },id){
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`, {
        "methodName": "getProjectServicesWithCompany",
        "parameters": [id.toString()],
        "serviceName": "ProjectdocuService"
      },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res=> {
      if (res.statusText === "OK" || res.status === 200){
        commit('setServicesWithCompanies',res.data)
      }
    });
  },

  async fetchTicket({ commit, dispatch }, {projectid, ticketId = null}) {

    commit('setLoading', true);

    console.log('fetchTicket', projectid, ticketId)
    // if(this.ticketid == '' || this.ticketid == null) {
    //   state.currentTicket = state.tickets.ticketmodel
    //   return
    // }
    if(ticketId == '' || ticketId == null) {
      commit('setTicket', state.tickets.ticketmodel)
      return
    }
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "getTicket",
        "parameters": [projectid, ticketId],
        "serviceName": "ProjectdocuTickets"
      },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
        console.log('FetchedTicket', res.data)
      let currentTicket = res.data

      if(currentTicket.items == null || !currentTicket.hasOwnProperty('items')) {
        currentTicket.items = {}
      }
      if(!currentTicket.items.hasOwnProperty('images')) {
        currentTicket.items.images = []
      }
      if(!currentTicket.items.hasOwnProperty('documents')) {
        currentTicket.items.documents = []
      }
      if(!currentTicket.items.hasOwnProperty('flaws')) {
        currentTicket.items.flaws = []
      }

      return currentTicket
    })
      .then(async (currentTicket) => {
        for (const image of currentTicket.items.images) {
          const index = currentTicket.items.images.indexOf(image)
          // console.log('forEach single item', image)
          await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`, {
            "methodName": "getPhoto",
              "parameters": [projectid, image.pdphotoid],
              "serviceName": "ProjectdocuTickets"
            },
            {
              headers: {
                apitoken: localStorage.apikey,
                deviceid: localStorage.deviceid,
                accept: 'application/json'
              }
            })
            .then((response) => {
              let photo = response.data[0]
              let date = photo.photodate
              // value.photodate = _this.formatDateBydot(date)
              photo.photodate_c = date
              photo.photodateBymonth = moment(String(date)).format('MMM DD')
              photo.photodateBytime = moment(String(date)).format('HH:mm')
              photo.photodateBydot = moment(String(date)).format('DD.MM.YYYY')
              photo.loaded = false

              Object.assign(image, photo, {description: image.description});
              if(!image.hasOwnProperty('src')) {
                image.src = require('@/assets/images/dumy.jpg');
              }
              currentTicket.items.images[index] = image
              return currentTicket
            })
            .catch((error) => {
              console.error(`There was an error updating the image with id ${image.photoid}: `, error);
            });

        }
        return currentTicket

      })
      .then(async currentTicket => {
        console.log('FetchFlaws')
        currentTicket = await dispatch('fetchFlaws', currentTicket)
        return currentTicket
      })
      .then(async currentTicket => {
        console.log('FetchDocs')
        currentTicket = await dispatch('fetchDocs', currentTicket)
        return currentTicket
      })
      .then(async currentTicket => {
        console.log('GetHistory')
        currentTicket = await dispatch('getHistory', currentTicket)
        return currentTicket
      })
      .then(async currentTicket => {
        console.log('GetComments')
        currentTicket = await dispatch('getComments', currentTicket)
        return currentTicket
      })
      .then(async currentTicket => {
        console.log('getShares')
        currentTicket = await dispatch('getShares', currentTicket)
        return currentTicket
      })
      .then(res => {
        // console.log('second then', JSON.stringify(res))
        dispatch('fetchImages', res)
        commit('setLoading', false);
      })
      .catch(error => {
      console.log(error)
    })
  },
  fetchImages({commit}, currentTicket) {
    // return ''
    let projectid = state.currentprojectid

    currentTicket.items.images.forEach((image, index) => {

      // console.log('fetchImage - Item', JSON.stringify(image), projectid, currentTicket)

      fetch(
        `${process.env.VUE_APP_GET_METHOD_URL}img&projectid=${projectid}&id=${image.pdphotoid}&token=${localStorage.sessiontoken}`,
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid
            }
          }
        )
        .then(response => response.blob())
        .then(response => {
          let reader = new FileReader();
          reader.readAsDataURL(response)
          reader.onload = function () {
            // console.log('Replace Photo', idx, _this.photos[idx])
            image.src = reader.result
            image.loaded = true
            if(index !== false) {
              currentTicket.items.images[index].src = reader.result
            }
          }
        })


        commit('setTicket', currentTicket)

      });


  },
  fetchFlaws({commit}, currentTicket) {

    let projectid = state.currentprojectid

    if(currentTicket.items.flaws.length >= 1) {
      for (const flaw of currentTicket.items.flaws) {
        const index = currentTicket.items.flaws.indexOf(flaw)

        // currentTicket.items.flaws.forEach((flaw, index) => {
        console.log('GetFlawDetails', flaw)
        // getFlawByFlawId
        axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
          {
            "methodName": "getFlawByFlawId",
            "parameters": [flaw.pdflawid, projectid],
            "serviceName": "ProjectdocuService"
          },
          {
            headers: {
              apitoken: localStorage.apikey,
              deviceid: localStorage.deviceid,
              accept: 'application/json'
            }
          }).then(res => {
          currentTicket.items.flaws[index] = Object.assign(flaw, res.data[0])
        })
          .catch(error => {
            console.log(error)
          })

      }
    }

    commit('setTicket', currentTicket)
    return currentTicket
    // commit('setTicket', currentTicket)
  },
  fetchDocs({commit}, currentTicket) {
    let projectid = state.currentprojectid

    if(currentTicket.items.documents.length >= 1) {
        // getReportByReportID
      for (const doc of currentTicket.items.documents) {
        const index = currentTicket.items.documents.indexOf(doc)

        console.log('GetDocumentsDetails', doc)
        // getFlawByFlawId
        axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
          {
            "methodName": "getReportByReportID",
            "parameters": [doc.pdreportid],
            "serviceName": "ProjectdocuService"
          },
          {
            headers: {
              apitoken: localStorage.apikey,
              deviceid: localStorage.deviceid,
              accept: 'application/json'
            }
          }).then(res => {
          currentTicket.items.documents[index] = Object.assign(doc, res.data[0])
        })
          .catch(error => {
            console.log(error)
          })

      }
    }
    commit('setTicket', currentTicket)
    return currentTicket
  },

  async downloadReport({commit}, report) {
    let url = `${process.env.VUE_APP_BASE_URL}${report.reporturl}&token=${localStorage.sessiontoken}`
    commit('setLoading', true);

    await fetch(url, {
      headers: {
        apitoken: localStorage.apikey,
        deviceid: localStorage.deviceid
      }
    }).then(response => response.blob())
      .then(response => {

        let blobUrl = URL.createObjectURL(response);
        window.open(blobUrl, '_blank');

        // let reader = new FileReader()
        // reader.readAsDataURL(response)
        // reader.onload = function () {
        //   let pdf = reader.result
        //   let link = document.getElementById('download-link');
        //   link.href = pdf
        //   link.download = `${moment(new Date()).format('YYYY-MM-DD')}_Report.pdf`
        //   link.click();
        // }
      });
    commit('setLoading', false);
  },
  async downloadFlaw({commit}, flaw) {
    commit('setLoading',true)
    let projectid = state.currentprojectid

    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`, {
      methodName:  "getFlawPdfByIds",
      serviceName: "ProjectdocuService",
      parameters: [projectid, [flaw.pdflawid], '', '', 0],
    },
    {
      headers: {
        apitoken: localStorage.apikey,
        deviceid: localStorage.deviceid,
        accept: 'application/json'
      }
    }).then(res => {
      console.log('PdFlawRes', res)
        return res
    })
    .then(async (res) => {
       let url = `${process.env.VUE_APP_BASE_URL}${res.data.objectType}&token=${localStorage.sessiontoken}`
       await fetch(url, {
         headers: {
           apitoken: localStorage.apikey,
           deviceid: localStorage.deviceid
         }
       }).then(response => response.blob())
       .then(response => {

         let blobUrl = URL.createObjectURL(response);
         window.open(blobUrl, '_blank');

         // let reader = new FileReader()
         // reader.readAsDataURL(response)
         // reader.onload = function () {
         //   let pdf = reader.result
         //   let link = document.getElementById('download-link');
         //   link.href = pdf
         //   link.download = `${moment(new Date()).format('YYYY-MM-DD')}_Mangelbericht.pdf`
         //   link.click();
         // }
       });
    })
    .catch(error => {
      this.$toast.error('Oops .. ! Something Went Wrong.')
    });

    commit('setLoading',false)
  },

  async getResponsibleUserList({commit}) {
    let projectid = state.currentprojectid
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "getResponsibleUsers",
        "parameters": [projectid],
        "serviceName": "ProjectdocuTickets"
      },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
        if (res.statusText === "OK" || res.status === 200) {
          console.log('Result of responsible users', res.data)
          commit('setResponsibleUsers', res.data)
        }
      })
      .catch(error => {
        console.log(error)
      })
  },

  async getHistory({commit}, currentTicket) {
    console.log('CurrentTicket History', JSON.parse(JSON.stringify(currentTicket), true))
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "getHistory",
        "parameters": [state.currentTicket.projectid, state.currentTicket.id],
        "serviceName": "ProjectdocuTickets"
      },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
        if(res.data.history !== undefined) {
          commit('SET_HISTORY', res.data.history);
          console.log('History found', res.data.history)
        }
    })
      .catch(error => {
        console.log(error)
      })


    return currentTicket
  },

  async getComments({commit, dispatch}, currentTicket) {
    console.log('CurrentTicket Comments', JSON.parse(JSON.stringify(currentTicket), true))
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "getComments",
        "parameters": [state.currentTicket.projectid, state.currentTicket.id],
        "serviceName": "ProjectdocuTickets"
      },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
        if(res.data.comments !== undefined) {
          commit('SET_COMMENTS', res.data.comments);
          console.log('Comments found', res.data.comments)
          currentTicket = dispatch('getHistory', currentTicket)
        }

      })
      .catch(error => {
        console.log(error)
      })


    return currentTicket
  },

  async sendInvitation({commit, dispatch}, params) {
    console.log('Send Invitation', params)

    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "addShare",
        "parameters": [state.currentTicket.projectid, state.currentTicket.id, params],
        "serviceName": "ProjectdocuTickets"
      },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(async res => {
        if(res.data.status == 'success') {
          console.log('getShares')
          await dispatch('getShares', state.currentTicket)
        }
      })


    return true

  },

  async getShares({commit}, currentTicket) {
    console.log('CurrentTicket getShares', JSON.parse(JSON.stringify(currentTicket), true))
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "getShares",
        "parameters": [state.currentTicket.projectid, state.currentTicket.id],
        "serviceName": "ProjectdocuTickets"
      },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
        console.log('getShare finish', res.data)
        if(res.data.shares !== undefined) {
          console.log('Shares found', res.data)
          commit('SET_SHARES', res.data.shares);
          if(currentTicket.status < 20 ) {
            commit('SET_STATUS', 20);
          }
        }
      })
      .catch(error => {
        console.log(error)
      })

    return currentTicket
  },

  async getShareoptions({commit}, email = '') {

    let projectid = state.currentprojectid
    return await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "getShareOptions",
        "parameters": [projectid, email],
        "serviceName": "ProjectdocuTickets"
      },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
        console.log('getShare finish', res.data)
        if(res.data.internal !== undefined) {
          state.shareoptions = res.data;
          return res.data
        }
      })
      .catch(error => {
        console.log(error)
      })
  },

  async setTicketStatus({commit, dispatch}, params) {
    let projectid = state.currentprojectid
    let ticketid = params.ticketid
    let status = params.status
    console.log('Set Ticket Status', params)

    return await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "setTicketStatus",
        "parameters": [projectid, ticketid, status],
        "serviceName": "ProjectdocuTickets"
      },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(async res => {
      if(res.data.status == 'success') {
        return true
      }
    })

  },

  async addComment({commit, dispatch}, payload) {
    console.log('AddComment', payload)

    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`, {
        "methodName": "addComment",
        "parameters": [state.currentTicket.projectid, state.currentTicket.id, payload.comment],
        "serviceName": "ProjectdocuTickets"
      },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      })
      .then(async (response) => {
        console.log('Current before set',state.currentTicket.comments)
        state.currentTicket.comments = response.data.comments

        dispatch('getHistory', state.currentTicket)
      })
      .catch(error => {
        console.log(error)
      })


  },

  removeTicket({ commit }, ticketId) {
    commit('REMOVE_TICKET', ticketId);
  }
}
const getters = {
  currentTicket: state => {
    return state.currentTicket
  },
  getuserById: state => userid => {
    let user = state.responsibleUsers.find(user => parseInt(user.pduserid) === parseInt(userid));

    if(user) {
      return user;
    }
    return {
      firstname: 'UK',
      lastname: ''
    }
  },
  tickets: state => {
    return state.tickets
  },
  statuslist: state => {
    return state.statuslist
  },
  getStatusColor: (state) => (statusId) => {
    const statusItem = state.statuslist.find(item => item.id === statusId);
    return statusItem ? statusItem.color : '#FFFFFF';
  },
  getStatusTitle: (state) => (statusId) => {
    const statusItem = state.statuslist.find(item => item.id === statusId);
    return statusItem ? statusItem.title : '';
  },
  currentview: state => {
    return state.currentView
  },
  searchString: state => state.searchstring


}



export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/tickets.js